import { render, staticRenderFns } from "./parent.vue?vue&type=template&id=dd6744b8&scoped=true&"
import script from "./parent.vue?vue&type=script&lang=js&"
export * from "./parent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6744b8",
  null
  
)

export default component.exports